import React, {Fragment,useContext} from "react";


import CaseProfileForm from "../components/ui/form-case-profile.js";
import { useCreateOrgCase, useUpdateOrgCase, useArchiveOrgCase, useGetOrgCases } from "../api/orgcases.js";
import ListEditComponent from "../components/ui/component-list-edit.js";
import CaseEditList from "../components/ui/list-edit-case.js";


import UserProfileContext from '../context/userprofilecontext.js';
import SnackbarContext from "../context/snackbar-context.js";
import { handleDisplayResponseResults } from "../api/api_util.js";
import { useConfirmAction } from "../components/ui/confirmactionhandler.js";
import CurrentOrgRequired from "../components/ui/current-org-required.js";

function ManageOrgCaseView() {

  const snackbarContext=useContext(SnackbarContext);

  const userProfileContext=useContext(UserProfileContext);

  const createOrgCase = useCreateOrgCase();

  const updateOrgCase = useUpdateOrgCase();

  const archiveOrgCase = useArchiveOrgCase();

  const useGetCasesForCurrentOrg = () => {
    return useGetOrgCases(userProfileContext?.userProfile?.currentOrg?.orgID, userProfileContext?.userProfile?.currentOrg);
  }

  if (userProfileContext.error){
    snackbarContext.openSnackbarError(userProfileContext.error)
  }

  const handleArchive = async (caseData) => {
    try {
      const caseID=caseData.caseID
      console.log(`in handleDelete, userData=${JSON.stringify(caseData)}`)
      const response = await archiveOrgCase(userProfileContext?.userProfile?.currentOrg?.orgID, caseID);
      // console.log('Delete Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatArchiveSuccess, formatArchiveError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };

  const {handleConfirmAction:handleConfirmArchive, ConfirmDialogElement:ConfirmArchiveDialog} = useConfirmAction(handleArchive, {title: "Confirm Archive", confirmMessage: "Please confirm you want to archive this case"})

  // if (userProfileContext.isLoading) {
  //   return (
  //     <Fragment>
  //       <PageSkeleton/>
  //     </Fragment>
  //   )
  // }

  const formatCreateSuccess = (result) => `Case ${result.item.caseName} creation in progress, we'll notify you when it's ready`
  const formatCreateError = (result) => `Case ${result.item.caseName} could not be created`

  const formatUpdateSuccess = (result) => `Case ${result.item.caseName} was updated`
  const formatUpdateError = (result) => `Case ${result.item.caseName} could not be updated`

  const formatArchiveSuccess = (result) => `Initiated archival of Case ${result.item.caseName}`
  const formatArchiveError = (result) => `Case ${result.item.caseName} could not be archived`



  const handleCreate = async (caseData) => {

    try {
      const response = await createOrgCase(userProfileContext?.userProfile?.currentOrg?.orgID, caseData);
      console.log('Create Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatCreateSuccess, formatCreateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };




  const handleUpdate = async (updatedData) => {
    try {

      const response = await updateOrgCase(userProfileContext?.userProfile?.currentOrg?.orgID, updatedData);
      console.log('Update Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatUpdateSuccess,formatUpdateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };



  const handleDelete = async (caseData) => {
    console.log(`in handleDelete, userData=${JSON.stringify(caseData)}`)
    snackbarContext.openSnackbarError("Delete not implemented")
  }




  return (
    <Fragment>
    <ListEditComponent
      editForm={CaseProfileForm}
      objectLabel="Case"
      editList={CaseEditList}
      useGetList={useGetCasesForCurrentOrg}
      createHandler={handleCreate}
      updateHandler={handleUpdate}
      deleteHandler={handleDelete}
      handleArchive={handleConfirmArchive} />
    <ConfirmArchiveDialog/>
    </Fragment>
  );
};

export default function ManageOrgCasePage() {
  return (
    <CurrentOrgRequired>
      <ManageOrgCaseView />
    </CurrentOrgRequired>
  );
}